var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorToastIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#FF0F00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5935 20.0657L15.0768 10.5946C15.3798 10.0712 15.5313 9.80947 15.729 9.72157C15.9014 9.64489 16.0983 9.64489 16.2707 9.72157C16.4684 9.80947 16.62 10.0712 16.923 10.5946L22.4063 20.0657C22.7104 20.591 22.8625 20.8537 22.84 21.0693C22.8204 21.2573 22.7219 21.4282 22.569 21.5394C22.3937 21.6668 22.0901 21.6668 21.4831 21.6668H10.5166C9.9096 21.6668 9.6061 21.6668 9.43079 21.5394C9.27789 21.4282 9.17937 21.2573 9.15977 21.0693C9.13729 20.8537 9.28936 20.591 9.5935 20.0657Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 14.0002V16.6668M15.9999 19.3335H16.0065M15.0768 10.5946L9.5935 20.0657C9.28936 20.591 9.13729 20.8537 9.15977 21.0693C9.17937 21.2573 9.27789 21.4282 9.43079 21.5394C9.6061 21.6668 9.9096 21.6668 10.5166 21.6668H21.4831C22.0901 21.6668 22.3937 21.6668 22.569 21.5394C22.7219 21.4282 22.8204 21.2573 22.84 21.0693C22.8625 20.8537 22.7104 20.591 22.4063 20.0657L16.923 10.5946C16.62 10.0712 16.4684 9.80947 16.2707 9.72157C16.0983 9.64489 15.9014 9.64489 15.729 9.72157C15.5313 9.80947 15.3798 10.0712 15.0768 10.5946Z",
    stroke: "#FF0F00",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorToastIcon);
export default __webpack_public_path__ + "static/media/error-toast-icon.ba6003b3b30675787ee5d93c0baca489.svg";
export { ForwardRef as ReactComponent };